import AtriumApi from "api";

const heartbeatResponseService = {
  // Get all survey responses with filtering/pagination
  getResponses: async (params = {}) => {
    try {
      const response = await AtriumApi.get("/v2/heartbeat/responses", {
        params,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching survey responses:", error);
      throw error;
    }
  },

  // Get single response by ID
  getResponseById: async (id) => {
    try {
      const response = await AtriumApi.get(`/v2/heartbeat/responses/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching survey response:", error);
      throw error;
    }
  },

  // Get responses for a specific campaign
  getResponsesByCampaign: async (campaignId, params = {}) => {
    try {
      const response = await AtriumApi.get("/v2/heartbeat/responses", {
        params: { ...params, campaignId },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching campaign responses:", error);
      throw error;
    }
  },

  // Get responses for a specific user
  getResponsesByUser: async (userId) => {
    try {
      const response = await AtriumApi.get(
        `/v2/heartbeat/responses/by-user/${userId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching user responses:", error);
      throw error;
    }
  },


  // Create a person from a survey response
  createPersonFromResponse: async (responseId) => {
    try {
      const response = await AtriumApi.post(
        `/v2/heartbeat/responses/${responseId}/create-person`
      );
      return response.data;
    } catch (error) {
      console.error("Error creating person from response:", error);
      throw error;
    }
  },
};

export default heartbeatResponseService;
